<div class="appointment-body" data-automation-attribute="div-appointment">
  <div class="body">
    <div class="filter-left">
      <table class="table-filter" data-automation-attribute="table-appointment">
        <tbody>
          <tr>
            <td style="width: 65%">
              <mat-form-field class="form-custom-width mgt-5" appearance="outline">
                <mat-label>
                  {{ "AppointmentPage.appointmenttype" | translate }}
                </mat-label>
                <mat-select [formControl]="appointmentTypeCtrl" [(ngModel)]="appointmentType"
                  [placeholder]="'AppointmentPage.appointmenttype' | translate"
                  (selectionChange)="appointmentTypeChange($event.value)" data-automation-attribute="select-appointment-type"
                  #appointmentTypeSelect>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="appointmentTypeDFltrCtrl" class="full-width" ngDefaultControl
                      [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of filteredappointmentType | async" [value]="option.code">
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="form-custom-width mgt-5" appearance="outline" *ngIf="isConsultationVisible">
                <mat-label>{{
                  "AppointmentPage.consultationtype" | translate
                  }}</mat-label>
                <mat-select [formControl]="teleCtrl" [(ngModel)]="teleconsultaion"
                  (selectionChange)="consultationOnchange($event, false)" 
                
                  >
                  <mat-option>
                    <ngx-mat-select-search [formControl]="teleFilterCtrl" class="full-width" ngDefaultControl
                      [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of filteredTelecom | async" [value]="option.code">
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="form-custom-width mgt-5" appearance="outline">
                <mat-label>
                  {{ "AppointmentPage.specialty" | translate }}
                </mat-label>
                <mat-select [formControl]="deptCtrl" [(ngModel)]="department"
                  [placeholder]="'AppointmentPage.doctordepartment' | translate"
                  (selectionChange)="departmentOnChange($event, false)"
                  data-automation-attribute="select-appointment-type" #deptTypeSelect>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="deptFilterCtrl" class="full-width" ngDefaultControl
                      [placeholderLabel]="'RegistrationPage.search' | translate"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let option of filteredDepts | async" [value]="option.code">
                    {{ option.desc }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
                <button mat-button color="primary" [disabled]="isQuickSearch" (click)="appoinmentSearch()"> {{ "CommonAppoinment.appoinmentSearch"
                  | translate }}</button> &nbsp;&nbsp;&nbsp;&nbsp;
                <button mat-button color="primary" [disabled]="isQuickSearch" (click)="recurringAppointments()"
                  *ngIf="isRecurringAppointments"> {{ "CommonAppoinment.recurringAppointments"
                  | translate }}</button> &nbsp;
                  <!-- <mat-checkbox [(ngModel)]="mulipleDoctor" name="muliple" [disabled]="multiDocCheckbox"
                  (click)="changeSingleToMultiple()">
                  {{ "AppointmentPage.multipledoc" | translate }}
                </mat-checkbox> -->
            </td>
            <td style="text-align: center; width: 5%" *ngIf="apptType == 'appt'"></td>
            <td style="text-align: right; width: 30%">
              <i class="material-icons icon-custom green md-18">fiber_manual_record</i>
              {{ "AppointmentPage.available" | translate }}
              <i class="material-icons icon-custom red md-18">fiber_manual_record</i>
              {{ "AppointmentPage.booked" | translate }}
              <i class="material-icons icon-custom grey md-18">fiber_manual_record</i>
              {{ "AppointmentPage.unavailable" | translate }}
              <i class="material-icons icon-custom blue md-18">fiber_manual_record</i>
              {{ "AppointmentPage.blockedHold" | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="section-app">
      <div class="section-left" *ngIf="isDoctorVisible">
         <div class="left-panel">
          <div class="panel-head" >
            {{ doctorsCount }} {{ "AppointmentPage.doctors" | translate }}
          </div>
          <div class="panel-body">
            <label *ngIf="!filteredDocsList || filteredDocsList.length == 0">{{
              "AppointmentPage.selectfilter" | translate
              }}</label>
 

<!-- <div class="div-doctor-list">
  <ul *ngIf="doctorList && doctorList.length > 0" class="doctor-list">
    <li *ngFor="let doctor of doctorList" [class.active]="activeDoctor && activeDoctor.id === doctor.id">
      <img class="imageCircle clip-circle" data-automation-attribute="imgDefaultUser" 
      [src]="doctor.imagePath ? doctor.imagePath :(doctor.gender == 'MALE' ? 'assets/images/doctor (3).png' : 'assets/images/doctor (8).png')" alt="Doctor Image">
      <span class="ib custom-label">
        <span style="font-weight: 500;font-size: 13px;">{{ doctor.desc }}</span><br>
        <button class="example-button-row" (click)="doctorOnChange(doctor)" mat-button color="primary">{{ doctor.available }}</button> 
      </span>
    </li>
  </ul>
</div> -->
<div class="div-doctor-list mt-10">
  <!-- Search Header -->
  <div>
    <mat-form-field class="full-width" style="width: 270px;" appearance="outline">
    <input 
      matInput 
      placeholder="{{ 'RegistrationPage.search' | translate }}" 
      [(ngModel)]="doctorSearch" 
      (input)="filterDoctorList()" />
      </mat-form-field>
  </div>

  <!-- Doctor List -->
  <ul *ngIf="filteredDocsList && filteredDocsList.length > 0" class="doctor-list">
    <li 
      *ngFor="let doctor of filteredDocsList" 
      [class.active]="activeDoctor && activeDoctor.id === doctor.id">
      
      <img 
        class="imageCircle clip-circle" 
        data-automation-attribute="imgDefaultUser" 
        [src]="doctor.imagePath ? doctor.imagePath : (doctor.gender == 'MALE' ? 'assets/images/doctor (3).png' : 'assets/images/doctor (8).png')" 
        alt="Doctor Image">
      
      <span class="ib custom-label">
        <span style="font-weight: 500; font-size: 13px;">{{ doctor.desc }}</span><br>
        <button 
          class="example-button-row" 
          (click)="doctorOnChange(doctor)" 
          mat-button 
          color="primary">
          {{ doctor.available }}
        </button>
      </span>
    </li>
  </ul>

  <!-- No Results -->
  <!-- <p *ngIf="filteredDocsList && filteredDocsList.length === 0">
    {{ 'No doctors available for the search term' | translate }}
  </p> -->
</div>
 
          </div>
        </div>
      </div>
      <!--sync fusion calendar start-->
      <div class="section-right">
        <div class="right-panel">
          <div class="col-lg-12 control-section">
            <div class="content-wrapper">
              <div class="schedule-overview">
                <!--header part starts here-->
                <div class="overview-header">
                  <div class="overview-titlebar">
                    <div class="left-panel">
                      <div class="schedule-overview-title" style="border: 1px solid transparent;">
                        <span style="font-weight: 500">{{
                          "AppointmentPage.appointmentcalendar" | translate
                          }}</span>
                      </div>
                    </div>
                    <div class="center-panel">
                      <button ejs-button id="timezoneBtn" cssClass="title-bar-btn" disabled="true">
                        <span style="font-size: 12px; font-weight: 500">{{
                          "AppointmentPage.product" | translate
                          }}</span>
                      </button>
                    </div>
                    <div class="right-panel">
                      <div *ngIf="isPermission">
                        <ejs-checkbox #wcheckbox [(ngModel)]="isHold" *ngIf="isHoldSplRights">
                        </ejs-checkbox>&nbsp;
                        <span style="font-weight: bold">
                          <mat-label *ngIf="isHoldSplRights" matTooltip="{{ 'AppointmentPage.hold' | translate }}">
                            {{ "AppointmentPage.hold" | translate }}
                          </mat-label>
                        </span>
                        &nbsp;
                        <ejs-checkbox #wcheckbox [(ngModel)]="unHold" *ngIf="isUnHoldSplRights">
                        </ejs-checkbox>&nbsp;
                        <span style="font-weight: bold">
                          <mat-label *ngIf="isHoldSplRights" matTooltip="{{ 'AppointmentPage.unhold' | translate }}">
                            {{ "AppointmentPage.unhold" | translate }}
                          </mat-label>
                        </span>
                      </div>
                      <!-- <div class="control-panel calendar-export">
                        <button
                          ejs-button
                          id="printBtn"
                          cssClass="title-bar-btn"
                          (click)="onPrintClick()"
                        >
                          <b>{{ "AppointmentPage.print" | translate }}</b>
                        </button>
                      </div> -->

                      <div class="control-panel calendar-export">
                        <button ejs-dropdownbutton id="exporting" (select)="onExportClick($event)"
                          [items]="exportItems">
                          <span style="font-weight: 500">{{
                            "AppointmentPage.export" | translate
                            }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="overview-content">
                  <div class="left-panel">
                    <div class="overview-scheduler ">
                      <ejs-schedule #scheduleObj cssClass="schedule-overview" height="100%" [group]="group"
                        [(currentView)]="currentView" timezone="UTC" [timeScale]="timeScale" [allowDragAndDrop]="false"
                        [allowResizing]="false" [eventSettings]="eventSettings" (popupOpen)="onPopupOpen($event)"
                        (navigating)="getAppointmentList($event)">
                        <e-views>
                           <e-view
                          *ngFor="let view of viewOptions"
                          [option]="view.option"
                          [displayName]="view.label">
                          <!-- <e-view option="Day"></e-view>
                          <e-view option="Week"></e-view>
                          <e-view option="WorkWeek"></e-view>
                          <e-view option="Month">--></e-view>

                          <!-- <e-view option="Agenda"></e-view> -->
                        </e-views>
                        <e-resources>
                          <e-resource field="CalendarId" title="Calendars" [dataSource]="resourceDataSource"
                            [query]="resourceQuery" [allowMultiple]="allowMultiple" name="Calendars"
                            textField="CalendarText" idField="CalendarId" colorField="CalendarColor">
                          </e-resource>
                        </e-resources>
                        <!-- Header template -->

                        <ng-template #quickInfoTemplatesHeader let-data>
                          <div class="quick-info-header">
                            <div class="quick-info-header-content" [ngStyle]="getHeaderStyles(data)">
                              <div class="quick-info-title">
                                {{ getHeaderTitle(data) }}
                              </div>
                              <div class="duration-text">
                                {{ getHeaderDetails(data) }}
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <!-- Content Template -->
                        <ng-template #quickInfoTemplatesContent let-data>
                          <ng-container [ngTemplateOutlet]="
                              data.elementType == 'cell' ? '' : eventContent
                            " [ngTemplateOutletContext]="{ data: data }"></ng-container>
                        </ng-template>
                        <ng-template #cellContent let-data="data">
                          <div class="quick-info-content">
                            <div class="e-cell-content">
                              <div class="content-area">
                                <ejs-textbox #titleObj id="title" placeholder="Title"></ejs-textbox>
                              </div>
                              <div class="content-area">
                                <ejs-dropdownlist id="eventType" #eventTypeObj [dataSource]="resourceDataSource"
                                  [fields]="calendarFields" placeholder="Choose Type" [value]="selectedResource"
                                  popupHeight="150pc">
                                </ejs-dropdownlist>
                              </div>
                              <div class="content-area">
                                <ejs-textbox #notesObj id="notes" placeholder="Notes"></ejs-textbox>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                        <ng-template #eventContent let-data="data">
                          <div class="quick-info-content">
                            <div class="event-content">
                              <div class="meeting-type-wrap">
                                <label>{{ data.subjectHeader }}</label>:
                                <span style=" display: inline-block">{{ data.Subject }}</span>
                              </div>
                              <div class="meeting-type-wrap" *ngIf="data.remarks">
                                <label>Remarks</label>:
                                <span style=" display: inline-block">{{ data.remarks }}</span>
                              </div>
                              <div class="meeting-subject-wrap">
                                <label>{{
                                  "AppointmentPage.type" | translate
                                  }}</label>:
                                <span >{{ getEventType(data) }}</span>
                              </div>
                              <!-- <div class="notes-wrap">
                                <label>{{
                                  "AppointmentPage.notes" | translate
                                  }}</label>:
                                <span>{{ data.Description }}</span>
                              </div> -->
                            </div>
                          </div>
                        </ng-template>
                        <!-- Footer Template -->
                        <ng-template #quickInfoTemplatesFooter let-data>
                          <ng-container [ngTemplateOutlet]="
                              data.elementType == 'cell' ? '' : eventFooter
                            " [ngTemplateOutletContext]="{ data: data }"></ng-container>
                        </ng-template>
                        <ng-template #cellFooter let-data="data">
                          <div class="e-cell-footer">
                            <button ejs-button id="more-details" cssClass="e-flat" (click)="buttonClickActions($event)">
                              {{ "AppointmentPage.moredetails" | translate }}
                            </button>
                            <button ejs-button id="add" cssClass="e-flat" [isPrimary]="true"
                              (click)="buttonClickActions($event)">
                              {{ "AppointmentPage.add" | translate }}
                            </button>
                          </div>
                        </ng-template>
                        <ng-template #eventFooter let-data="data">
                          <div class="e-event-footer">
                            <button ejs-button id="delete" cssClass="e-flat" (click)="buttonClickActions($event)">
                              {{ "AppointmentPage.delete" | translate }}
                            </button>
                            <button ejs-button id="more-details" cssClass="e-flat" [isPrimary]="true"
                              (click)="buttonClickActions($event)">
                              {{ "AppointmentPage.moredetails" | translate }}
                            </button>
                          </div>
                        </ng-template>
                      </ejs-schedule>
                    </div>
                  </div>
                  <div class="right-panel hide">
                    <div class="control-panel e-css">
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.firstdayofweek" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-dropdownlist id="weekFirstDay" [dataSource]="weekDays" (change)="onWeekDayChange($event)"
                            [value]="firstDayOfWeek" [fields]="fields" popupHeight="150px">
                          </ejs-dropdownlist>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.workweek" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-multiselect #workWeekDaysObj id="workWeekDays" [dataSource]="weekDays"
                            [showClearButton]="false" [showDropDownIcon]="true" [mode]="checkboxMode" [fields]="fields"
                            popupHeight="150px" [value]="workDays"
                            (change)="onWorkWeekDayChange($event)"></ejs-multiselect>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.resources" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-multiselect #resouresObj id="resources" [dataSource]="resourceDataSource"
                            [mode]="checkboxMode" [fields]="calendarFields" popupHeight="150px"
                            [showClearButton]="false" [showDropDownIcon]="true" [value]="calendarsValue"
                            (change)="onResourceChange($event)">
                          </ejs-multiselect>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.timezone" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-dropdownlist id="timezone" [dataSource]="timezoneData"
                            (change)="onTimezoneChange($event)" value="Etc/GMT" [fields]="fields" popupHeight="150px">
                          </ejs-dropdownlist>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.daystarthour" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-timepicker id="dayStartHour" showClearButton="false" [value]="dayStartHourValue"
                            (change)="onDayStartHourChange($event)">
                          </ejs-timepicker>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.dayendhour" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-timepicker id="dayEndHour" showClearButton="false" [value]="dayEndHourValue"
                            (change)="onDayEndHourChange($event)">
                          </ejs-timepicker>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.workstarthour" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-timepicker id="workHourStart" showClearButton="false" [value]="workStartHourValue"
                            (change)="onWorkStartHourChange($event)">
                          </ejs-timepicker>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{ "AppointmentPage.workendhour" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-timepicker id="workHourEnd" showClearButton="false" [value]="workEndHourValue"
                            (change)="onWorkEndHourChange($event)"></ejs-timepicker>
                        </div>
                   </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 25px; margin: 0">{{
                            "AppointmentPage.slotduration" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-dropdownlist id="slotDuration" [dataSource]="timeSlotDuration" [fields]="timeSlotFields"
                            (change)="onTimescaleDurationChange($event)" [value]="timeSlotDurationValue"
                            popupHeight="150px"></ejs-dropdownlist>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.slotinterval" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-dropdownlist id="slotInterval" [dataSource]="timeSlotCount"
                            (change)="onTimescaleIntervalChange($event)" [value]="timeSlotCountValue"
                            popupHeight="150px">
                          </ejs-dropdownlist>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.timeformat" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-dropdownlist id="timeFormat" [dataSource]="timeFormatData"
                            (change)="onTimeFormatChange($event)" [fields]="timeSlotFields" [value]="timeFormatValue"
                            popupHeight="150px"></ejs-dropdownlist>
                        </div>
                      </div>
                      <div class="col-row">
                        <div class="col-left">
                          <label style="line-height: 34px; margin: 0">{{
                            "AppointmentPage.weeknumbers" | translate
                            }}</label>
                        </div>
                        <div class="col-right">
                          <ejs-dropdownlist id="weekNumber" [dataSource]="weekNumberData"
                            (change)="onWeekNumberChange($event)" [fields]="timeSlotFields" [value]="weekNumberValue"
                            popupHeight="150px"></ejs-dropdownlist>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--sync fusion calendar end------------->
      <ng-template *ngIf="isHidden" #calendarPopover>
        <h3>{{ toolData }}</h3>
      </ng-template>
    </div>
  </div>
</div>